/**
 * [spec-008 T028] Adapta uma ENTREGA do agente — o metadado que
 * `GET /conversations/<id>/artefatos` devolve (`{id_objeto, nome,
 * content_type, bytes, sha256, entregue_em, id_run}`) — para o shape que
 * `composer-attachments.vue` já desenha (`{name, size, type}`, a anatomia de
 * um `File` do browser).
 *
 * É o MESMO movimento de `paraItemDeAnexo` (`anexo-persistido-para-item.js`),
 * por um motivo que já está registrado lá: o anexo do gestor e a entrega do
 * agente são o mesmo objeto para quem olha — arquivo com nome, tipo e tamanho
 * — e desenhá-los em duas anatomias diferentes na MESMA conversa foi o defeito
 * que o S-3 corrigiu na bolha do usuário.
 *
 * ★ Não é `File`/`Blob`: não há bytes aqui, só metadado. Os bytes só chegam no
 * clique, em base64, pela rota de download (`apiArtefatos.baixar`). Por isso
 * `composer-attachments` nunca cria object URL para estes itens — ver
 * `ehSemBytesNaMemoria` lá.
 *
 * `id_objeto` viaja junto: é a chave da miniatura (`chaveDoArquivo`) E o que
 * o download pede ao servidor. Sem `nome`, cai num rótulo genérico — nome
 * vazio na tela é pior que um rótulo honesto.
 */
const NOME_PADRAO = 'arquivo'

export function paraItemDeArtefato(artefato) {
  if (!artefato) return null
  return {
    name: artefato.nome || NOME_PADRAO,
    size: artefato.bytes,
    type: artefato.content_type,
    id_objeto: artefato.id_objeto,
  }
}
